import { API_ENDPOINTS } from "../config/api";
import { apiClient } from "./api-client";

// Types for authentication
export interface LoginParams {
  email: string;
  password: string;
}

export interface User {
  id: string;
  firstName: string | null;
  lastName: string | null;
  username: string;
  role: "USER" | "ADMIN";
  email: string | null;
  avatar: string | null;
  phone: string | null;
  isActive: boolean | null;
  createdAt: string;
  updatedAt: string;
}

export interface AccessToken {
  expiresIn: number;
  token: string;
}

export interface LoginResult {
  user: User;
  accessToken: AccessToken;
}

export interface ApiError {
  statusCode: number;
  message: string;
  error: string;
}

/**
 * Login API
 * POST /auth/login
 */
export async function login(body: LoginParams): Promise<LoginResult> {
  return apiClient.post<LoginResult>(API_ENDPOINTS.AUTH.LOGIN, body, true);
}

/**
 * Get current user API
 * GET /v1/auth/me
 */
export async function getCurrentUser(): Promise<User> {
  return apiClient.get<User>(API_ENDPOINTS.AUTH.ME);
}

/**
 * Logout function
 */
export function logout(): void {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("user");
}

/**
 * Check if user is authenticated
 */
export function isAuthenticated(): boolean {
  return !!localStorage.getItem("accessToken");
}

/**
 * Get stored access token
 */
export function getToken(): string | null {
  return localStorage.getItem("accessToken");
}

/**
 * Store authentication data
 */
export function storeAuthData(data: LoginResult): void {
  localStorage.setItem("accessToken", data.accessToken.token);
  localStorage.setItem("user", JSON.stringify(data.user));
}

/**
 * Get stored user data
 */
export function getStoredUser(): User | null {
  const userStr = localStorage.getItem("user");
  return userStr ? JSON.parse(userStr) : null;
}
